import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import AxiosManager from '../../utils/axios-manager';
import { captureAxiosError } from '../../utils/sentry-helper';
import appConfig from '../../../config/config';

axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.withCredentials = true;
const debug = process.env.NODE_ENV === 'development';

axios.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        const { requestId } = config;
        if (requestId) {
            const source = axios.CancelToken.source();
            config.cancelToken = source.token;
            AxiosManager.getInstance(debug).addRequest(requestId, source.cancel);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

axios.interceptors.response.use(
    (response: AxiosResponse) => {
        const { requestId } = response.config;
        if (requestId) {
            AxiosManager.getInstance(debug).removeRequest(requestId);
        }
        return response.data;
    },
    (error: AxiosError | undefined) => {
        //undefined in cancel request or offline
        if (error?.response) {
            const { config, status } = error?.response;
            const { requestId, skipHandlers } = config;

            if (requestId) {
                AxiosManager.getInstance(debug).removeRequest(requestId);
            }
            if (status) {
                captureAxiosError(error);
            }
            if (status === 401) {
                const uri = window.encodeURIComponent(`${appConfig.appUrl}/business`);
                window.location.href = `${appConfig.authUrl}/login?redirect_uri=${uri}`;
            }
            if ([400, 404, 500].includes(status) && !skipHandlers?.includes(status)) {
                return Promise.reject(error);
            } else {
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    },
);

axios.cancel = (requestId: string, reason?: string) => {
    if (requestId) {
        AxiosManager.getInstance(debug).cancelRequest(requestId, reason);
    }
};
